import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LayoutService } from '@layout/services/layout.service';
import { RoutesUtil } from '@shared-features/utils/routes.util';
import { ColorsConstant } from '@shared/constants';

export interface PasswordExpiryDialogData {
  daysRemaining: number;
}

interface ExpiryLevel {
  badgeBg: string;
  iconBadgeBg: string;
  icon: string;
  title: string;
  body: string;
  params: { days: number };
}

@Component({
  selector: 'app-password-expiry-dialog',
  templateUrl: './password-expiry-dialog.component.html',
  styleUrls: ['./password-expiry-dialog.component.scss'],
})
export class PasswordExpiryDialogComponent implements OnInit {
  readonly MAX_DAYS = 15;
  readonly WARNING_THRESHOLD = 11;
  readonly DANGER_THRESHOLD = 6;

  daysRemaining!: number;
  level!: ExpiryLevel;
  progressPercent!: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PasswordExpiryDialogData,
    private dialogRef: MatDialogRef<PasswordExpiryDialogComponent>,
    private router: Router,
    public layoutService: LayoutService

  ) {}

  ngOnInit(): void {
    this.daysRemaining = this.data.daysRemaining;
    this.progressPercent = Math.round((this.daysRemaining / this.MAX_DAYS) * 100);
    this.level = this.buildTheme(this.daysRemaining);
  }

  get daysLabel(): string {
    if (this.daysRemaining === 0) return 'sharedFeatures.PasswordExpiredLabel';
    return 'sharedFeatures.DaysRemainingLabel';
  }

  onRenew(): void {
    this.dialogRef.close('renew');
    this.router.navigate([RoutesUtil.AuthResetPasswordBy.url()]);
  }

  onRemindLater(): void {
    this.dialogRef.close('remind');
  }

  private buildTheme(days: number): ExpiryLevel {
    if (days >= this.WARNING_THRESHOLD) {
      return {
        badgeBg: ColorsConstant.primary500,
        iconBadgeBg: ColorsConstant.primary600,
        icon: 'outline-warn',
        title: 'sharedFeatures.NoticeTitle',
        body: 'sharedFeatures.NoticeBody',
        params: { days },
      };
    }

    if (days >= this.DANGER_THRESHOLD) {
      return {
        badgeBg: ColorsConstant.MdAccent500,
        iconBadgeBg: ColorsConstant.MdAccent600,
        icon: 'outline-danger',
        title: 'sharedFeatures.ReminderTitle',
        body: 'sharedFeatures.ReminderBody',
        params: { days },
      };
    }

    return {
      badgeBg: ColorsConstant.MdAccent100,
      iconBadgeBg: ColorsConstant.Secondary200,
      icon: 'outline-alarm',
      title: 'sharedFeatures.UrgentTitle',
      body: days === 0 ? 'sharedFeatures.UrgentBodyExpired' : 'sharedFeatures.UrgentBodyDays',
      params: { days },
    };
  }
}
